
import { Box, Pagination, styled, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, useMediaQuery } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { constantsMsg } from "./constantsEU";

/**
 * rows: {
    id: 0
    , group: null
    , groupName: null
    , maximumValue: null
    , footnote: null
    , constraintException: null
 * }
 * 
 * @param {combinationRows} param0 
 * @returns 
 */
export const CombinationDialog = ({ combinationRows }) => {

  //*********************************************************************************************
  // 定数定義
  //*********************************************************************************************
  const [tablePage, setTablePage] = useState(1);
  const recordCount = 5; // テーブルに表示する行数
  const isMobile = useMediaQuery('(max-width: 1000px)'); // SP表示用境界値

  // ヘッダー定義
  const headCells = [
    { id: 0, column: 'group', label: '添加物グループ', }
    , { id: 1, column: 'groupName', label: '名称', }
    , { id: 2, column: 'maximumValue', label: '最大値\n(適宜mg/lまたはmg/kg)', }
    , { id: 3, column: 'footnote', label: '脚注', }
    , { id: 4, column: 'constraintException', label: '制約/例外', }
  ];

  // ボディー定義
  const [sortState, setSortState] = useState({
    rows: [combinationRows], //配列
    order: "desc", // 降順ソート中("desc") or 昇順ソート中("asc")
    key: headCells[0].column // ソート中の列名
  });

  //*********************************************************************************************
  // 関数定義
  //*********************************************************************************************

  /*
    ソート機能
  */
  function handleClickSortColumn(column) {
    // 選択中の列をもう一回クリックしたときは降順/昇順を切り替える。
    // 選択中ではない列をクリックしたときはまず降順でソートする。
    const isDesc = column === sortState.key && sortState.order === "desc";
    const nextOrder = isDesc ? "asc" : "desc";
    const sortRule = { asc: [1, -1], desc: [-1, 1] };
    const sortedRows = sortState.rows.slice().sort((a, b) => {
      if (a[`${column}`] > b[`${column}`]) {
        return sortRule[nextOrder][0];
      } else if (a[column] < b[column]) {
        return sortRule[nextOrder][1];
      } else {
        return 0;
      }
    });

    setSortState({
      rows: sortedRows,
      order: nextOrder,
      key: column
    });
  }

  /*
    改行コードを改行タグに変換し、リンク変換用文字列を消す
  */
  function linkConvart(text) {
    const matchTxt = "@link@";
    var convartTxt = text.replace(matchTxt, "");
    // "#"をカッコに変換
    convartTxt = convartTxt.replace("#", "（");
    convartTxt = convartTxt.replace("#", "）");
    
    return convartTxt.split('\n').map(t => (<>{t}<br /></>))
  }

  /*
    改行コードを改行タグに変換
  */
  function brTagConvart(text) {
    // "#"をカッコに変換
    text = text.replace("#", "（");
    text = text.replace("#", "）");
    return text.split('\n').map(t => (<>{t}<br /></>))
  }

  /*
    表示中のページ数を取得
  */
  function getStartIdx(tablePage, recordCount, adjustedArr) {
    if (adjustedArr.length == 0) {
      return 1
    }

    // 配列が初期化されている場合は1を返す
    if (adjustedArr.length == 1) {
      if (adjustedArr[0].group == null) {
        return 1
      }
    }

    let page = tablePage * recordCount - recordCount
    return page
  }

  //*********************************************************************************************
  // ハンドラ
  //*********************************************************************************************

  // 表示中のページ
  const CustomizedLabel = ({ from, to, count, page }) => {
    return `全${count !== -1 ? count : `more than ${to}`}件中 ${from}-${to}`;
  };

  // ページ切り替え
  const handleChange = (event, index) => {
    setTablePage(index);
  }

  //*********************************************************************************************
  // 更新処理
  //*********************************************************************************************

  useEffect(() => {
    setSortState({
      rows: combinationRows,
      order: "desc",
      key: headCells[0].column
    });
    setTablePage(1);
  }, [combinationRows]);


  //*********************************************************************************************
  // styledComponents
  //*********************************************************************************************
  const styles = {
    grid: {
      display: "flex",
      padding: "20px",
      marginTop: isMobile ? "50px" : "none",

      // // 表示中のページ
      ".MuiToolbar-root-MuiTablePagination-toolbar .MuiTablePagination-actions": {
        display: "flex"
      },
      // 「表示中のページ」の左にあるスペース(非表示にする)
      ".css-levciy-MuiTablePagination-displayedRows": {
        position: "absolute",
        marginTop: isMobile ? "-30px" : "5px"
        // marginTop: `${displayedRowsMargin}px`
      },
      // // ぺージャー
      "MuiTablePagination-root": {
        width: "-webkit-fill-available"
      },
      ".MuiToolbar-root MuiToolbar-gutters MuiToolbar-regular MuiTablePagination-toolbar MuiToolbar-root-MuiTablePagination-toolbar": {
        width: "100%",
        display: "inline-grid"
      },
      "MuiToolbar-root MuiToolbar-gutters MuiToolbar-regular MuiTablePagination-toolbar MuiToolbar-root-MuiTablePagination-toolbar": {
        width: "-webkit-fill-available"
      },
      ".MuiTablePagination-root": {
        flexFlow: "column"
      },
      ".MuiTablePagination-toolbar": {
        display: "contents"
      },
      // ".MuiSvgIcon-root": {
      //   backgroundColor: "none"
      // }
    },
  };

  //*********************************************************************************************
  // コンポーネント
  //*********************************************************************************************

  return (
    <>
      {sortState.rows.length != 0 ?
        <Box position="relative" justifyContent="space-evenly">

          <TablePagination
            component="div"
            count={combinationRows.length}
            rowsPerPage={recordCount}
            labelDisplayedRows={CustomizedLabel}
            Icon
            page={tablePage - 1}
            rowsPerPageOptions={[]}
            showFirstButton
            showLastButton
            onPageChange={handleChange}
            size={isMobile ? "small" : "midiam"}
            sx={styles.grid}

            ActionsComponent={(props) => (
              <Pagination
                siblingCount={ isMobile? 1 : undefined}
                count={Math.ceil(props.count / recordCount)}
                page={tablePage}
                rowsPerPage={props.rowsPerPage}
                showFirstButton
                showLastButton
                className={props.className}
                onChange={props.onPageChange}
                sx={{ right: 0, overflowX: isMobile ? "hidden" : undefined }}
                size={isMobile ? "small" : "midiam"}
              />
            )}
          />

          <TableContainer >
            <Table>
              {/* 組み合わせテーブル（ヘッダー） */}
              <TableHead>
                <TableRow>
                  {/* 添加物グループ */}
                  <CtableHeader sx={{ minWidth: "130px" }} key={`table-header-col-${headCells[0].id}`} sortDirection={sortState.key === headCells[0].column ? sortState.order : false}>
                    <TableSortLabel active={sortState.key === headCells[0].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[0].column)}>
                      {headCells[0].label}
                    </TableSortLabel>
                  </CtableHeader>
                  {/* 名称 */}
                  <CtableHeader sx={{ minWidth: "200px" }} key={`table-header-col-${headCells[1].id}`} sortDirection={sortState.key === headCells[1].column ? sortState.order : false}>
                    <TableSortLabel active={sortState.key === headCells[1].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[1].column)}>
                      {headCells[1].label}
                    </TableSortLabel>
                  </CtableHeader>
                  {/* 最大値(適宜mg/lまたはmg/kg) */}
                  <CtableHeader sx={{ minWidth: "170px" }} key={`table-header-col-${headCells[2].id}`} sortDirection={sortState.key === headCells[2].column ? sortState.order : false}>
                    <TableSortLabel active={sortState.key === headCells[2].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[2].column)}>
                      {brTagConvart(headCells[2].label)}
                    </TableSortLabel>
                  </CtableHeader>
                  {/* 脚注 */}
                  <CtableHeader sx={{ minWidth: "250px" }} key={`table-header-col-${headCells[3].id}`} sortDirection={sortState.key === headCells[3].column ? sortState.order : false}>
                    <TableSortLabel active={sortState.key === headCells[3].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[3].column)}>
                      {headCells[3].label}
                    </TableSortLabel>
                  </CtableHeader>
                  {/* 制約/例外 */}
                  <CtableHeader sx={{ minWidth: "250px" }} key={`table-header-col-${headCells[4].id}`} sortDirection={sortState.key === headCells[4].column ? sortState.order : false}>
                    <TableSortLabel active={sortState.key === headCells[4].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[4].column)}>
                      {headCells[4].label}
                    </TableSortLabel>
                  </CtableHeader>
                </TableRow>
              </TableHead>

              {/* 組み合わせテーブル（ボディー）*/}
              <TableBody>
                {(recordCount > 0 ? sortState.rows.slice(getStartIdx(tablePage, recordCount, sortState.rows), tablePage * recordCount) : sortState.rows).map((d, i, a) => {
                  return (
                    <TableRow hover key={`table-row-row-${d.id}`}>
                      {/* 添加物グループ */}
                      <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[0].id}`}>
                        {d.group}
                      </CtableCell>
                      {/* 名称 */}
                      <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[1].id}`}>
                        {d.groupName}
                      </CtableCell>
                      {/* 最大値(適宜mg/lまたはmg/kg) */}
                      <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[2].id}`}>
                        {brTagConvart(d.maximumValue)}
                      </CtableCell>
                      {/* 脚注 */}
                      <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[3].id}`}>
                        {linkConvart(d.footnote)}
                      </CtableCell>
                      {/* 制約/例外 */}
                      <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[4].id}`}>
                        {brTagConvart(d.constraintException)}
                      </CtableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        :
        <div style={{ backgroundColor: "#EDEEF2", textAlign: "center", padding: "50px", marginTop: "30px", marginBottom: "30px" }}>
          <span>{constantsMsg.STR_MODAL_NOTFOUND}</span>
        </div>
      }
    </>
  );
}

// テーブルcss
const CtableHeader = styled(TableCell)(() => ({
  backgroundColor: "#EDEEF2",
  textAlign: 'center',
  fontSize: '12px',
  border: `1px solid #C7C7C7`,

  padding: `5px`,
  display: "table-cell",
}));

const CtableCell = styled(TableCell)(() => ({
  border: `1px solid #C7C7C7`,
  padding: "5px",
}));